const rightClick = {
  state: {
    // 右键菜单
    rightMenu: {
      status: "none",
      top: "0px",
      left: "0px",
      list: []
    },
  },
  mutations: {
    // 更新右键菜单数据
    updateRightMenuStatus(state, menuObj) {
      state.rightMenu.status = menuObj.status;
      state.rightMenu.top = menuObj.top;
      state.rightMenu.left = menuObj.left;
      state.rightMenu.list = menuObj.list;
    },
  },
  actions: {

  }
};

export default rightClick;
